import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";

import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialog, DialogPosition } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { AppDateAdapter, APP_DATE_FORMATS } from "src/app/core/services/date-format.service";
import { FilterDialogService } from "src/app/core/services/filter-dialog.service";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";
import { getdateformatService } from "src/app/core/services/get-date-format.service";
import { DeleteGameDialogBoxComponent, SuccessDialogComponent, UploadCsvDialogBoxComponent } from "src/app/shared/components/dialog-box";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { Router } from "@angular/router";
import { CustomerSubscriptionProfileComponent } from "../customer-subscription-profile/customer-subscription-profile.component";
import { SubscriptionAddNewCustomerComponent } from "../../components/subscription-add-new-customer/subscription-add-new-customer.component";

@Component({
  selector: 'app-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.css'],
    providers: [
      { provide: DateAdapter, useClass: AppDateAdapter },
      { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    ],
})
export class SubscriptionListComponent implements OnInit {

  validWidgets = null;
   merchantID = this.tokenService.getMerchantId();
   pageSize = 10;
   pageIndex = 1;
   customers = [];
   totalCustomers;
   showCustomers = "all";
   searchValue = "";
   timeout;
   sub: Subscription;
   @ViewChild("search") searchElement: ElementRef;
   loading = true;
   overallTotalCustomers=null;
   isAdmin : boolean = true; 
   previousState="";
   selectedStatuses = [];
   selectedSubscriptions = [];
   cancel=true;
   
   constructor(
     private _WidgetConfigService: WidgetConfigService,
     private dialog: MatDialog,
     private apiCall: ApiCallService,
     private tokenService: TokenStorageService,
     private filterData: FilterDialogService,
     private tokenStorage: TokenStorageService,
     private date_format: getdateformatService,
     private snackBar: SnackbarCollection,
     private _i18nDynamicTranslate: TranslateDynamicText,
     public router: Router
   ) {
     window["screen-name"] = "ALL CUSTOMERS";
   }
 
 
   ngOnInit() {
     if(this.tokenStorage.getqId() === 'null'){
       this.isAdmin = true;
     }
     else{
       this.isAdmin = false;
     }
     this.getWidgets();
     this.getCustomers();
   }

 
   async getWidgets() {
     this.validWidgets = await this._WidgetConfigService.getWidget();
   }

 
   openCustomerDetailsDialog(customer): void {
     const dialogRef = this.dialog.open(CustomerSubscriptionProfileComponent, {
       data: {
         customer: customer,
       },
       height: "95%",
       disableClose: true,
       panelClass: "customer-profile-dialog-container",
     });
 
    //  dialogRef.afterClosed().subscribe(updatedCustomerFromPopup => {
    //    let updatedCustomer = this.customers.find((customer)=>
    //      customer.merchantCustomerId == updatedCustomerFromPopup.merchantCustomerId);
    //    console.log(updatedCustomer);
    //    updatedCustomer['customerName'] = updatedCustomerFromPopup['customerName'];
    //    updatedCustomer['birthday'] = updatedCustomerFromPopup['birthday'];
    //    updatedCustomer['anniversary'] = updatedCustomerFromPopup['anniversary'];
    //  });
   }
 

 
   getCustomers(resetPagination?) {
     this.loading = true;
     if(resetPagination) this.pageIndex = 1;
     this.apiCall
       .getSubscriptionList(
        this.merchantID,
        this.pageIndex,
        this.pageSize,
        this.selectedStatuses, // Example: ['ACTIVE', 'INACTIVE']
        this.selectedSubscriptions, // Example: ['GOLD', 'SILVER']
        this.searchValue // 
       )
       .subscribe((response) => {
         this.showCustomers = "all";
           this.customers = (response["body"]['content']);
         this.totalCustomers = response["body"]['totalElements'];
         this.overallTotalCustomers = this.overallTotalCustomers?this.overallTotalCustomers:response["body"]['totalElements'];
         this.loading = false;
       },(err)=>{
         this.snackBar.openSnackBar('Failed to fetch custom list',5000);
       });
   }

 
   refreshPaginatedData(event) {
     this.pageIndex = event.pageIndex + 1;
     this.pageSize = event.pageSize;
     if (this.showCustomers === "all") this.getCustomers();
     else this.searchCustomer(this.searchValue, false);
   }
 
 
   onKeySearch(event: any, resetPagination) {
     clearTimeout(this.timeout);
     var $this = this;
     let searchValue = event.trim();
     console.log(searchValue);
     if(searchValue.length !==0){
       this.timeout = setTimeout(function () {
         // if (event.keyCode != 13) {
           $this.searchCustomer(searchValue, resetPagination);
         // }
       }, 600);
     }
     else if ((this.previousState!=searchValue) && searchValue.length === 0) {//if search value is 0 and to handle only search with spaces
      this.searchValue="";
      this.getCustomers(resetPagination);
     }
     this.previousState =searchValue
   }
 
   searchCustomer(searchValue, resetPagination) {
     this.loading = true;
     if (resetPagination) this.pageIndex = 1;
     if (this.sub) {
       this.sub.unsubscribe();
     }
    this.sub = this.apiCall.getSubscriptionList(
      this.merchantID,
      this.pageIndex,
      this.pageSize,
      this.selectedStatuses, // Example: ['ACTIVE', 'INACTIVE']
      this.selectedSubscriptions, // Example: ['GOLD', 'SILVER']
      searchValue // 
     )
       .subscribe((response) => {
         this.showCustomers = "search"; 
           if (this.searchValue !== searchValue) {
             this.customers = (response["body"]['content']);
           } else {
             (response["body"]['content']).forEach((element) => {
               this.customers.push(element);
             });
           }
         this.searchValue = searchValue;
         this.totalCustomers = response["body"]['totalElements'];
         this.loading = false;
       },(err)=>{
         this.snackBar.openSnackBar('Failed to search customer',5000);
       });
     if (searchValue === "") this.getCustomers();
   }
 
   getDateInFormatForDisplay(dateInp: number): string | null {
     if (!dateInp) return null; 
     let date = new Date(dateInp);
     const year = date.getFullYear();
     const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
     const month = monthNames[date.getMonth()];
     const day = date.getDate();
     return `${month} ${day}, ${year}`;
   }


  getStatusClass(status: string) {
    if (status === 'ACTIVE') {
        return 'active';
    } else if (status === 'INACTIVE') {
        return 'inactive';
    } else if (status === 'CANCELLED') {
        return 'cancelled';
    }
    return '';  
}

 addNewCustomer() {
   {
      const dialogRef = this.dialog.open(SubscriptionAddNewCustomerComponent, {
        panelClass: "no-padding-dialog-popup",
        width: "783px",
        height: "500px",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const dialogRef2 = this.dialog.open(SuccessDialogComponent, {
            panelClass: "no-padding-dialog-popup",
            width: "20%",
            data: {
              message: this._i18nDynamicTranslate.transform(
                "Customer has been succesfully created ",
                ["POS_PAGE"]
              ),
              buttonText: this._i18nDynamicTranslate.transform("OK", [
                "POS_PAGE",
              ]),
            },
          });
          this.getCustomers();
          dialogRef2.afterClosed();
        } else {
          dialogRef.close();
        }
      });
    }
  }

}
